module.exports = __webpack_public_path__ + "img/Food.3f8ac5a1.jpg";